import {
	FETCH_ARRIVAL_LIST,
	FAIL_FETCH_ARRIVAL_LIST,
	SET_ARRIVAL_LIST_DATA,
	RESET_ARRIVAL_LIST_STATE,
	RESET_PROCESS_ERROR,
	GET_PDF_ITEMS_ARRIVAL,
	FAIL_GET_PDF_ITEMS_ARRIVAL,
	SET_PDF_ITEMS_ARRIVAL,
	CLEAR_PDF_ITEMS_ARRIVAL,
	UPDATE_ARRIVAL_FLAG,
	FAIL_UPDATE_ARRIVAL_FLAG,
	SUCCESS_UPDATE_ARRIVAL_FLAG,
	UNDO_ARRIVAL_FLAG,
	FAIL_UNDO_ARRIVAL_FLAG,
	SUCCESS_UNDO_ARRIVAL_FLAG,
	FETCH_CSV_DATA_ARRIVAL,
	FAIL_FETCH_CSV_DATA_ARRIVAL,
	SET_CSV_DATA_ARRIVAL, SET_ARRIVAL_LIST_STATE,
} from '../actions';

import moment from 'moment';
import {downloadCsvData} from "../common/utils/download-csv";
const init = {
	data:[],
	isFetching: false,
	error: undefined,
	pdfPath : undefined,
	isProcessError : false
};
const initialState = Object.assign({},init);
export default function arrivalListSettings(state = initialState, action) {
	let ret = Object.assign({}, state, {});
    switch (action.type) {
		case FETCH_ARRIVAL_LIST:
		case UPDATE_ARRIVAL_FLAG:
		case UNDO_ARRIVAL_FLAG:
		case GET_PDF_ITEMS_ARRIVAL:
		case FETCH_CSV_DATA_ARRIVAL:
			ret.isFetching = true;
			return ret;
		case FAIL_FETCH_ARRIVAL_LIST:
		case FAIL_UPDATE_ARRIVAL_FLAG:
		case FAIL_UNDO_ARRIVAL_FLAG:
		case FAIL_GET_PDF_ITEMS_ARRIVAL:
		case FAIL_FETCH_CSV_DATA_ARRIVAL:
			ret.isFetching = false;
			ret.error = action.payload.err;
			ret.isProcessError = true;
			return ret;
		case SET_ARRIVAL_LIST_DATA:
			ret.data = action.payload.data;
			ret.isFetching = false;
			return ret;
		case RESET_ARRIVAL_LIST_STATE:
			Object.keys(init).forEach((key)=>{
				ret[key] = init[key];
			})
			return ret;
		case SUCCESS_UPDATE_ARRIVAL_FLAG:
			ret.isFetching = false;
			ret.data = action.payload.arrivalData;
			return ret;
		case SUCCESS_UNDO_ARRIVAL_FLAG:
			ret.isFetching = false;
			ret.data = action.payload.arrivalData;
			return ret;
		case RESET_PROCESS_ERROR:
			ret.isProcessError = false;
			return ret;
		case SET_PDF_ITEMS_ARRIVAL:
			ret.pdfPath = action.payload.pdfPath;
			ret.isFetching = false;
			return ret;
		case CLEAR_PDF_ITEMS_ARRIVAL:
			ret.pdfPath = undefined;
			return ret;
		case SET_CSV_DATA_ARRIVAL:
			const csvData = action.payload.csvData;
			const columns = action.payload.columns;
			const now = moment().format('YYYYMMDDhhmmss');
			downloadCsvData("着荷伝票"+now, columns,csvData);
			ret.isFetching = false;
			return ret;
		case SET_ARRIVAL_LIST_STATE:
			return Object.assign({}, state, action.payload)
		default:
			return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/arrival-list.js